// Oct 31 2026, user's ask: an Administration screen where an admin assigns an
// item that SAP treats as an in-house sub-assembly (it has its own BOM) but
// which is really bought from a vendor at that plant, so it starts getting a
// store request like any other purchased component. Ex: 100162725AL1.
import { Storefront } from "@phosphor-icons/react";
import { Toaster } from "@/components/ui/sonner";
import { NavTabs } from "@/components/NavTabs";
import { SapConnectionStatus } from "@/components/SapConnectionStatus";
import { ErpConnectionStatus } from "@/components/ErpConnectionStatus";
import { StoreIssuedItemsCard } from "@/components/StoreIssuedItemsCard";

export default function StoreIssuedItemsPage() {
  return (
    <div className="min-h-screen bg-[#F9FAFB] flex flex-col" data-testid="store-issued-items-page">
      <Toaster position="top-right" />
      <header className="min-h-16 bg-[#0E7C86] shadow-[0_1px_3px_0_rgba(16,24,40,0.15)] flex items-center justify-between px-3 sm:px-5 shrink-0 z-10 gap-2 sm:gap-4">
        <div className="flex items-center gap-3 shrink-0" data-testid="app-title">
          <div className="w-8 h-8 rounded-lg bg-white/15 flex items-center justify-center shrink-0">
            <Storefront size={18} weight="fill" className="text-white" />
          </div>
          <div className="flex flex-col leading-tight">
            <span className="font-heading text-[16px] font-bold text-white tracking-tight">Production Control</span>
            <span className="font-sans text-[12px] text-white/70 hidden sm:inline">Store-Issued Items</span>
          </div>
        </div>
        <div className="w-px h-7 bg-white/25 shrink-0" />
        <div className="flex items-center gap-3 flex-1 justify-start min-w-0">
          <NavTabs />
        </div>
        <SapConnectionStatus />
        <ErpConnectionStatus />
      </header>

      <div className="p-4 sm:p-6 max-w-5xl w-full mx-auto">
        <StoreIssuedItemsCard />
      </div>
    </div>
  );
}
